module.exports = __webpack_public_path__ + "static/childprotection_card_img3@2x-6346df5a1dc46e1790065787685630c6.jpg";